import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Keyword } from '../../interfaces/keyword.model';

/*
  Generated class for the KeywordProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class KeywordProvider {

  keywords: Keyword[];

  constructor(public http: HttpClient, public storage: Storage) {}

  getKeywords() {
    return new Promise<Keyword[]>((resolve, reject) => {
      this.storage.get("keywords").then((data:Keyword[]) => {
        this.keywords = data;
        resolve(this.keywords);
      });
    });
  }
 
  updateKeywordList(synchroList){
    return new Promise((resolve, reject) => {
      let add = this.addKeywords(synchroList);
      let del = this.deleteKeywords(synchroList);
      let up = this.updateKeywords(synchroList);
      
      Promise.all([add, del, up]).then(data => { 
        this.storage.set("keywords", this.keywords).then(() => {
          resolve();
        });
      });
    });
  }

  deleteKeywords(synchroList) {
    return new Promise((resolve, reject) => {
      let deletedSyncList = synchroList.Deleted;

      if(deletedSyncList.length > 0) {
        for(let i = 0; i < this.keywords.length; i++){
            let cat = this.keywords[i];
            if(deletedSyncList.indexOf(cat.KeywordId) !== -1){
                this.keywords.splice(i, 1);
                i--;
            }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  updateKeywords(synchroList){
    return new Promise((resolve, reject) => {
      let updatedSyncList = synchroList.Updated;

      if(updatedSyncList.length > 0){
        for(let i = 0; i < updatedSyncList.length; i++){
          let index = this.keywords.findIndex(item => item.KeywordId == updatedSyncList[i].KeywordId)
          if(index !== -1){
            this.keywords[index] = updatedSyncList[i];
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  addKeywords(synchroList) {
    return new Promise((resolve, reject) => {
      let addedSyncList = synchroList.Added;

      if(addedSyncList.length > 0){
        for(let i = 0; i < addedSyncList.length; i++){
          let keyword = addedSyncList[i];
          let found = this.keywords.some(item => item.KeywordId == keyword.KeywordId);
          if(!found){
              this.keywords.push(keyword);
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/keyword/keyword.ts